<template>
<div id="secure">

    <NewTopMenu />
    <div class="container">

        <div class="columns">
            <div class="column is-12">
                <div class="card">
                    <div class="card-header" style="padding: 10px;">
                        <div class="columns">
                            <!-- <div class="column">
                                <b-button rounded v-on:click="viewLeaderboard()" size="is-small">Back to Leaderboard</b-button>
                            </div> -->
                            <div class="column is-10 last-refresh">
                                Last refresh at {{ currentDate }}, {{ currentTime }}
                            </div>
                            <div class="column">
                                <b-select id="display" name="display" v-model="display" size="is-small">
                                    <option value="1">Top 10</option>
                                    <option value="2">Top 20</option>
                                    <option value="3">Top 30</option>
                                    <option value="4">Top 40</option>
                                    <option value="5">Top 50</option>
                                    <option value="6">Top 100</option>
                                    <option value="7">Top 300</option>
                                </b-select>
                            </div>
                        </div>
                    </div>
                    <div class="card-content">
                        <div>
                            <loading :active.sync="isLoading1" 
                                :can-cancel="true" 
                                :is-full-page="false">
                            </loading>
                            <b-button rounded>Top Students/Users for {{ monthDisplay }} {{ currentYear }}</b-button>
                            <b-table :data="sortTop(topStudents,display,'student')" :columns="topStudentsColumns" :mobile-cards="false"></b-table>
                        </div>
                        <br/>
                        <div>
                            <loading :active.sync="isLoading2" 
                                :can-cancel="true" 
                                :is-full-page="false">
                            </loading>
                            <b-button rounded>Top Classes/Departments for {{ monthDisplay }} {{ currentYear }}</b-button>
                            <b-table :data="sortTop(topClasses,display,'class')" :columns="topClassesColumns" :mobile-cards="false">
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import "./public/style.scss";
const helper = require("../../config/helper")

export default {
    name: "LeaderboardLive",
    components: {
        NewTopMenu,
        Loading
    },
    data() {
        return {
            schoolID: "",
            currentDate: "",
            currentTime: "",
            monthDisplay: "",
            topStudents: [],
            topClasses: [],
            isLoading1: false,
            isLoading2: false,
            currentDay: 0,
            currentYear: 0,
            lastYear: 0,
            currentMonth: 0,
            display: 1,
            enableLiveLeaderboard: false,
            props: [],
            timer: '',
            topStudentsColumns: [
                {
                    field: 'number',
                    label: '#',
                    width: '20',
                    numeric: true
                },
                {
                    field: 'firstName',
                    label: 'Name',
                },
                {
                    field: "class",
                    label: '',
                },
                {
                    field: 'tempNumber1',
                    label: 'Points',
                    centered: true
                }
            ],
            topClassesColumns: [
                {
                    field: 'number',
                    label: '#',
                    width: '20',
                    numeric: true
                },
                {
                    field: "class",
                    label: 'Class/Department',
                },
                {
                    field: 'tempNumber1',
                    label: 'Points',
                    centered: true
                }
            ],
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    created() {
        this.schoolID = localStorage.getItem('schoolID');

        // this.timer = setInterval(this.callGetLeaderboard, 60 * 1000 * 30)    //reload every 30 minutes
        this.callGetLeaderboard()
    },
    mounted(){
    },
    methods: {
        viewLeaderboard(){
            this.$router.push({
                name: "Leaderboard"
            });
        },
        async callGetLeaderboard(){
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth()+1; //January is 0!
            this.currentYear = today.getFullYear();
            this.lastYear = this.currentYear - 1
            this.currentMonth = today.getMonth() + 1;  //since month starts from 0
            this.currentDay = today.getDate();
            this.duration = this.currentMonth

            this.monthDisplay = helper.displayMonth(this.currentMonth);
            this.currentDate = dd + " " + this.monthDisplay + " " + this.currentYear;
            this.currentTime = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            
            var getTopStudents = await this.getLeaderboard("student")
            var getTopClasses = await this.getLeaderboard("kelas")
        },
        async getLeaderboard(category){
            let self = this
            console.log("entering getLeaderboard for " + category)

            if (category == "student"){
                self.topStudents = []
                self.isLoading1 = true
            }else if (category == "kelas"){
                self.topClasses = []
                self.isLoading2 = true
            }else{
                console.log("Invalid category!")
                return false;
            }

            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/leaderboardV2/live', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                category: category,
            })
            .then(response => {
                if (category == "student"){
                    self.topStudents = response.data.studentList
                    for (var i = 0; i < self.topStudents.length; i++){
                        self.topStudents[i].firstName = self.topStudents[i].firstName + " " + self.topStudents[i].lastName
                    }
                    self.isLoading1 = false
                    return true;
                }else if (category == "kelas"){
                    self.topClasses = response.data.kelasList
                    self.isLoading2 = false
                    return true;
                }
            })
            .catch(e => {
                console.log(e)
                if (category == "student"){
                    self.isLoading1 = false
                }else{
                    self.isLoading2 = false
                }
                if (e.response.status === 401) {
                    Toast.open({
                        message: e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: "The server is handling too many requests now. Please try again later",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })

        },
        sortTop(arrays,display,what){
            var show = 100
            display = parseInt(display)
            switch(display) {
                case 1:
                    show = 10
                    break;
                case 2:
                    show = 20
                    break;
                case 3:
                    show = 30
                    break;
                case 4:
                    show = 40
                    break;
                case 5:
                    show = 50
                    break;
                case 6:
                    show = 100
                    break;
                case 7:
                    show = 300
                    break;
                default:
                    show = 100
                    // code block
            }
            var output = _.orderBy(arrays, 'tempNumber1', 'desc').splice(0,show); //we're using the magical lodash function here to sort by points and return the top needed
            for (var i = 0; i < output.length; i++){
                output[i].number = i + 1
                if (what=="student"){
                    if (this.category == "kelas"){
                        output[i].class = this.getKelasName(this.kelasID)
                    }else{
                        if (output[i].kelasID){
                            output[i].class = output[i].kelasID.level + " " + output[i].kelasID.name
                        }
                    }
                }else if (what=="class"){
                    output[i].class = output[i].level + " " + output[i].name
                }
                output[i].tempNumber1 = this.roundTo2DecimalPlaces(output[i].tempNumber1)
            }
            return output
        },
        getKelasName(kelasID){
            var findKelas = _.find(this.kelasList, {'_id': kelasID})    //use lodash to find particular object inside array
            var kelasLevelName = "";
            if (findKelas){
                kelasLevelName = findKelas.level + " " + findKelas.name
            }
            return kelasLevelName;
        },
        roundTo2DecimalPlaces(points){  //use lodash to round the points to 2 decimal places
            return _.round(points, 2)
            // return _.round(points, 2).toFixed(2)
        },
    },
};
</script>

<style scoped>
.bottom-border{
    border-bottom: 1px solid #CCC
}
.container{
    padding: 10px;
}
.text-center{
    text-align: center;
}
.last-refresh{
    font-weight: normal;
    font-size: 0.9rem;
    font-style: italic;
    margin-top:5px;
}
</style>


// WEBPACK FOOTER //
// src/components/LeaderboardLive.vue